import React, { useEffect, useRef } from "react";
import { useInstantSearch } from "react-instantsearch-hooks-web";

export function ScrollTo({ children }) {
  const { use } = useInstantSearch();
  const containerRef = useRef(null);

  useEffect(() => {
    const middleware = () => {
      return {
        onStateChange() {
          const className = document.activeElement.getAttribute("class");
          if (className?.toLowerCase() !== "ais-pagination-link") return;
          // containerRef.current.scrollIntoView();
          window.scrollTo({ top: 0, behavior: "smooth" });
        },
      };
    };

    return use(middleware);
  }, [use, containerRef]);

  return (
    <div ref={containerRef} className="ais-ScrollTo">
      {children}
    </div>
  );
}
